import React from 'react'

import styled from '@emotion/styled'

import AuthBase from "../components/AuthBase";
import {alertActionTypes} from "../_constants";
import AuthError from "../components/AuthError";

// STYLE ##########################################################

const Message = styled('div')`
  margin-bottom: 32px;
`;

// COMPONENT ##########################################################

function ErrorMessage(props) {
    const {title, messages, alert} = props;

    const messageElements = messages.map((message, key) =>
        <Message key={key}>{message}</Message>
    );

    return (
        <AuthBase title={title} maxWidth={props.maxWidth}>
            {alert && alert.type === alertActionTypes.ERROR &&
            <AuthError error={alert.message.errorMsg}/>
            }
            {messageElements}
        </AuthBase>
    );
}

export default ErrorMessage;
